import { render, staticRenderFns } from "./TablePlaceholder.vue?vue&type=template&id=01906116&scoped=true"
import script from "./TablePlaceholder.vue?vue&type=script&lang=ts"
export * from "./TablePlaceholder.vue?vue&type=script&lang=ts"
import style0 from "./TablePlaceholder.vue?vue&type=style&index=0&id=01906116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01906116",
  null
  
)

export default component.exports